import DashboardVendas from '../../components/DashboardVendas/DashboardVendas';

const DashboardPage = () => {
    return <DashboardVendas />;
};

export default DashboardPage;
